export default __webpack_public_path__ + "static/media/img_login.5ba15fe4.svg";